<template>
  <v-chip
    v-if="!Array.isArray(value)"
    color="blue-lighten-3"
    closable
    @click:close="$emit('click:close', null)">
    {{ title }}: {{ textValue }}
  </v-chip>
  <div v-else class="d-flex ga-3 flex-wrap">
    <active-filter-item
      v-for="v in value"
      :key="v"
      :title="title"
      :value="v"
      :filter-map-item="filterMapItem"
      @click:close="
        $emit(
          'click:close',
          value.filter(i => i !== v)
        )
      "></active-filter-item>
  </div>
</template>

<script lang="ts">
import { getDirectory } from '@/directory'
import { computed, PropType } from 'vue'
import { CustomDate } from 'best-modules/utils'
import { FilterMapItem } from './types'

export default {
  name: 'ActiveFilterItem',
  emits: ['click:close'],
  props: {
    title: {
      type: String,
    },
    value: {
      type: [String, Number, Array] as PropType<
        string | number | string[] | number[]
      >,
    },
    filterMapItem: {
      type: Object as PropType<FilterMapItem>,
    },
  },
  setup(props) {
    const textValue = computed<string>(() => {
      if (props.filterMapItem.directory) {
        return getDirectory(props.filterMapItem.directory, null, {
          type: 'collection',
        }).getItem(props.value as unknown as string)?.name
      }
      if (props.filterMapItem.component === 'checkbox') {
        return props.value === 'true' ? 'Так' : 'Ні'
      }
      if (
        ['input-date', 'input-date-range'].includes(
          props.filterMapItem.component
        )
      ) {
        return new CustomDate(props.value as string).toString()
      }

      return String(props.value)
    })

    return { textValue }
  },
}
</script>

<style scoped lang="scss"></style>
